import { Fragment } from 'react';
import { Field, EventWithDataHandler, change } from 'redux-form';
import connect from 'components/Shared/connect';
import { useToggle } from 'hooks';
import { rm } from 'utils';
import { Button } from 'components/Button';
import { ToolTip } from 'components/Shared/ToolTip';
import { RenderLabeledInput } from 'components/Shared/Form/inputs';
import * as rules from 'views/CheckoutPage/validation';
import { isMobileLayout } from 'components/Shared/responsive';
import styles from './rotForm.scss';
import commonStyles from '../styles.scss';

interface OwnProps {
  isManual: boolean;
  onBlur: EventWithDataHandler<React.FocusEvent<Element>>;
}

interface MergedProps extends OwnProps {
  resetField: (field: string) => void;
  isMobile: boolean;
}

const RotForm = ({ isManual, onBlur, isMobile, resetField }: MergedProps) => {
  const [isApartment, toggleIsApartment] = useToggle(false);

  const toggleLabel = isApartment
    ? rm('checkout_rotreduction_type_house')
    : rm('checkout_rotreduction_type_apartment');
  const identityPattern = isMobile ? '[0-9]*' : rules.identityNumberRegexString;

  const toggleRotType = () => {
    if (isManual) {
      resetField('address.identityNumber');
    }
    resetField('address.cadastral');
    resetField('address.apartmentOrganisationNumber');
    resetField('address.apartmentNumber');

    toggleIsApartment();
  };

  const formProps = {
    identityPattern,
    onBlur,
    isManual
  };

  return (
    <div>
      <div className={styles.header}>
        <strong>
          {rm('checkout_rotreduction_header')} <ToolTip text={rm('checkout_rotreduction_body')} />
        </strong>
        <Button appearance="link" onClick={toggleRotType} type="button">
          {toggleLabel}
        </Button>
      </div>
      {isApartment ? <ApartmentForm {...formProps} /> : <HouseForm {...formProps} />}
    </div>
  );
};

interface FormProps {
  identityPattern: string;
  onBlur: () => void;
  isManual: boolean;
}

const HouseForm = ({ identityPattern, onBlur, isManual }: FormProps) => (
  <Fragment>
    <Field
      name="identityNumber"
      inputMode="numeric"
      pattern={identityPattern}
      validate={rules.identityNumber}
      className={commonStyles.input}
      component={RenderLabeledInput}
      props={{ customLabel: rm('checkout_identityheader_private') }}
      onBlur={onBlur}
      disabled={!isManual}
    />
    <Field
      name="cadastral"
      validate={rules.cadastral}
      className={commonStyles.input}
      component={RenderLabeledInput}
      props={{ customLabel: rm('checkout_rotreduction_propertyname') }}
      onBlur={onBlur}
    />
  </Fragment>
);

const ApartmentForm = ({ identityPattern, onBlur, isManual }: FormProps) => (
  <Fragment>
    <Field
      name="identityNumber"
      inputMode="numeric"
      pattern={identityPattern}
      validate={rules.identityNumber}
      className={commonStyles.input}
      component={RenderLabeledInput}
      props={{ customLabel: rm('checkout_identityheader_private') }}
      onBlur={onBlur}
      disabled={!isManual}
    />
    <Field
      name="apartmentOrganisationNumber"
      inputMode="numeric"
      pattern={rules.organizationNumberRegexString}
      validate={rules.apartmentOrganisationNumber}
      className={commonStyles.input}
      component={RenderLabeledInput}
      props={{ customLabel: rm('checkout_rotreduction_organisationnum') }}
      onBlur={onBlur}
    />
    <Field
      name="apartmentNumber"
      validate={rules.apartmentNumber}
      className={commonStyles.input}
      component={RenderLabeledInput}
      props={{ customLabel: rm('checkout_rotreduction_apartmentnum') }}
      onBlur={onBlur}
    />
  </Fragment>
);

export default connect<MergedProps, OwnProps>(
  state => ({
    isMobile: isMobileLayout(state)
  }),
  dispatch => ({
    resetField: (field: string) => dispatch(change('checkout', field, ''))
  })
)(RotForm);
